import React, { Component } from 'react';
import { connect } from 'react-redux';


class TicketListToolbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCardRemove: false,
            isFullScreen: false,
            isCollapsed: false,
        };
    }
    render() {
        const { user } = this.props;
        return (
            <div className="row">
                <div className="col-xl-12 col-md-12">
                    <div className="card">
                        <div className="card-body w_user">
                            <div className="user_avtar">
                                <img className="rounded-circle" src="../../assets/images/sm/avatar8.jpg" alt="" />
                            </div>
                            <div className="wid-u-info">
                                <h5>{user.userFullName}</h5>
                                {/* <p className="text-muted m-b-0">{`${user.}`} </p> */}
                                {/* <ul className="list-unstyled">
                                    <li>
                                        <h5 className="mb-0">270</h5>
                                        <small>Followers</small>
                                    </li>
                                    <li>
                                        <h5 className="mb-0">310</h5>
                                        <small>Following</small>
                                    </li>
                                    <li>
                                        <h5 className="mb-0">908</h5>
                                        <small>Liks</small>
                                    </li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Sobre Mi</h3>
                            <div className="card-options ">
                                {/* <a  className="card-options-collapse" data-toggle="card-collapse"><i className="fe fe-chevron-up"></i></a>
                                <a  className="card-options-remove" data-toggle="card-remove"><i className="fe fe-x"></i></a> */}
                            </div>
                        </div>
                        <div className="card-body">
                            {/* <p>Hola soy  {user.fullName}</p> */}
                            <ul className="list-group">
                                <li className="list-group-item">
                                    <b>DNI</b>
                                    <div>{user.userDni}</div>
                                </li>
                                <li className="list-group-item">
                                    <b>Año Lectivo </b>
                                    <div>2025</div>
                                </li>
                                <li className="list-group-item">
                                    <b>Aula </b>
                                    <div>{user.sectionName}</div>
                                </li>
                                <li className="list-group-item">
                                    <b>Sede </b>
                                    <div>{user.campusName}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = state => ({
    dropDownMenu: state.settings.isDropDownMenu
})

const mapDispatchToProps = dispatch => ({
    
})
export default connect(mapStateToProps, mapDispatchToProps)(TicketListToolbar);